export default function assignPlace(basicEntity: any, placeBlob: any) {
    if (basicEntity && placeBlob) {
        let newEntity = {
            ...basicEntity,
            ...{
                name: placeBlob.name,
                telephone: placeBlob.telephone,
                city: placeBlob['address/commonCity'],
            },
        };

        if (placeBlob.address) {
            newEntity = {
                ...newEntity,
                ...{
                    address: { ...placeBlob.address },
                },
            };
        }
        return newEntity;
    }

    return null;
}
